import React from 'react';

import { genericErrorMessage } from '@consumer-frontend/nc-utils';

import { NcErrorPage } from '../NcErrorPage';

export type NcGenericErrorPageT = React.FC;

export const NcGenericErrorPage: NcGenericErrorPageT = () => (
  <NcErrorPage
    displaySupportText
    message={genericErrorMessage}
  />
);
